module.exports = __webpack_public_path__ + "media/src/images/zu_teaching01_page20-974cbfcd43b1b8b65fa530aaf7642763.gif";